// extracted by mini-css-extract-plugin
export default {"quote-source":"Social_quote-source__8Fo80","quote-source__person":"Social_quote-source__person__Y6wU5","quote":"Social_quote__bYgBI"};